module.exports = __webpack_public_path__ + "img/6@3x.26d36c7e.png";